import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './slices/counterSlice';
import disputeReducer from './slices/disputeSlice';
import chatReducer from './slices/chat';
import authReducer from './slices/authSlice';
import { testApi } from './services/test';
import { disputeService } from './services/disputeService';
import { postsManagementService } from './services/postsManagementService';
import { chatService } from './services/chatService';
import { reviewService } from './services/Review';
import { usersReportsService } from './services/reports/usersReports';
import { jobsReportsService } from './services/reports/jobsReports';

import { lookupsService } from './services/lookups';
import { budgetReportsService } from './services/reports/budgetReports';
import { categorySlice } from './slices/categorySlice';
import { categoryServices } from './services/Category';
import { publicSlice } from './slices/publicSlice';
import { coinsOffersServices } from './services/coinsControl';
import { SupportService } from './services/SupportService';
import { postsService } from './services/postsService';
import { coinsReportsService } from './services/reports/coinsReports';
import { commissionReportsService } from './services/reports/commissionReports';
import { disputeReportsService } from './services/reports/disputeReports';
import { skillsRequestsService } from './services/skills';
import { quizSlice } from './slices/QuizSlice';
import { quizService } from './services/quiz';
import { authService } from './services/authService';
import { businessRequestsApi } from './services/business-requests';
import { adminMembersService } from './services/adminMembers';
import { commissionService } from './services/commission';
import { kpisService } from './services/kpis';
import { customerKPIsSlice } from './slices/kpis';
import { operationAdminService } from './services/operationAdmin';
import { productService } from './services/products';
import productsReducer from './slices/ProductsSlice';
import { addSellerService } from './services/addSellerService';
import sellerProfileReducer from './slices/sellerProfileSlice';
import { sellerProfileCreationService } from './services/sellerProfileCreationService';
import { promotionSlotsService } from './services/promotionSlotsService';
import { promotionDurationsService } from './services/promotionDurationsService';
import { promotionsService } from './services/promotionsService';
import { marketplacePlansService } from './services/marketplacePlansService';
import { configLogsService } from './services/configLogsService';
import { biddingProposalsService } from './services/biddingProposalsService';
import { biddingPostsService } from './services/biddingPostsService';
import { biddingContractsService } from './services/biddingContractsService';
import { feedbackService } from './services/feedbackService';
import modalSlice from './slices/Modals';
import { reportsService } from './services/reports';
import reportFiltersReducer from './slices/reportFiltersSlice';

export const store = configureStore({
  reducer: {
    modals: modalSlice.reducer,
    counter: counterReducer,
    dispute: disputeReducer,
    chat: chatReducer,
    auth: authReducer,
    products: productsReducer,
    [testApi.reducerPath]: testApi.reducer,
    [disputeService.reducerPath]: disputeService.reducer,
    [postsManagementService.reducerPath]: postsManagementService.reducer,
    [chatService.reducerPath]: chatService?.reducer,
    [reviewService.reducerPath]: reviewService?.reducer,
    [feedbackService.reducerPath]: feedbackService?.reducer,
    [usersReportsService.reducerPath]: usersReportsService?.reducer,
    [jobsReportsService.reducerPath]: jobsReportsService?.reducer,
    [lookupsService.reducerPath]: lookupsService?.reducer,
    [budgetReportsService.reducerPath]: budgetReportsService?.reducer,
    [categorySlice.reducerPath]: categorySlice.reducer,
    [categoryServices.reducerPath]: categoryServices.reducer,
    [publicSlice.reducerPath]: publicSlice.reducer,
    [coinsOffersServices.reducerPath]: coinsOffersServices?.reducer,
    [SupportService.reducerPath]: SupportService?.reducer,
    [postsService.reducerPath]: postsService?.reducer,
    [coinsReportsService.reducerPath]: coinsReportsService?.reducer,
    [commissionReportsService.reducerPath]: commissionReportsService?.reducer,
    [disputeReportsService.reducerPath]: disputeReportsService?.reducer,
    [skillsRequestsService.reducerPath]: skillsRequestsService?.reducer,
    [quizSlice.reducerPath]: quizSlice?.reducer,
    [quizService.reducerPath]: quizService?.reducer,
    [commissionService.reducerPath]: commissionService?.reducer,
    [operationAdminService.reducerPath]: operationAdminService?.reducer,
    [kpisService.reducerPath]: kpisService?.reducer,
    [customerKPIsSlice.reducerPath]: customerKPIsSlice?.reducer,
    [authService.reducerPath]: authService.reducer,
    [businessRequestsApi.reducerPath]: businessRequestsApi.reducer,
    [adminMembersService.reducerPath]: adminMembersService.reducer,
    [productService.reducerPath]: productService.reducer,
    [addSellerService.reducerPath]: addSellerService.reducer,
    sellerProfile: sellerProfileReducer,
    [sellerProfileCreationService.reducerPath]:
      sellerProfileCreationService.reducer,
    [reportsService.reducerPath]: reportsService.reducer,
    reportFilters: reportFiltersReducer,
    [promotionSlotsService.reducerPath]: promotionSlotsService.reducer,
    [promotionDurationsService.reducerPath]: promotionDurationsService.reducer,
    [promotionsService.reducerPath]: promotionsService.reducer,
    [marketplacePlansService.reducerPath]: marketplacePlansService.reducer,
    [configLogsService.reducerPath]: configLogsService.reducer,
    [biddingProposalsService.reducerPath]: biddingProposalsService.reducer,
    [biddingPostsService.reducerPath]: biddingPostsService.reducer,
    [biddingContractsService.reducerPath]: biddingContractsService.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      testApi.middleware,
      disputeService.middleware,
      postsManagementService.middleware,
      chatService.middleware,
      reviewService.middleware,
      feedbackService.middleware,
      usersReportsService.middleware,
      jobsReportsService.middleware,
      lookupsService.middleware,
      budgetReportsService.middleware,
      categoryServices.middleware,
      coinsOffersServices.middleware,
      SupportService.middleware,
      postsService.middleware,
      coinsReportsService.middleware,
      commissionReportsService.middleware,
      disputeReportsService.middleware,
      skillsRequestsService.middleware,
      quizService.middleware,
      commissionService.middleware,
      operationAdminService.middleware,
      kpisService.middleware,
      authService.middleware,
      businessRequestsApi.middleware,
      adminMembersService.middleware,
      productService.middleware,
      addSellerService.middleware,
      sellerProfileCreationService.middleware,
      reportsService.middleware,
      promotionSlotsService.middleware,
      promotionDurationsService.middleware,
      promotionsService.middleware,
      marketplacePlansService.middleware,
      configLogsService.middleware,
      biddingProposalsService.middleware,
      biddingPostsService.middleware,
      biddingContractsService.middleware,
    ]),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
